/**
 * Filtres de la liste des prises en charge (boutons au-dessus du tableau). « En cours » est celui par défaut,
 * à l'ouverture de la liste comme au clic sur son accueil. Les statuts partent à l'API séparés par des virgules.
 */
export const FILTRES_PEC = [
    {titre: "Tout", couleur: "dark", status: ""},
    {titre: "En cours", couleur: "warning", status: ["ARRIVED", "DIAGNOSTIC", "WAITING_REPAIR", "REPARATION", "EN_COURS"]},
    {titre: "À surveiller", couleur: "info", status: ["WAITING_PIECES", "WAITING_CLIENT"]},
    {titre: "À récupérer", couleur: "success", status: ["TO_GET_BACK_SUCESSFULLY", "TO_GET_BACK"]},
];

export const FILTRE_PEC_DEFAUT = FILTRES_PEC[1];

/** Le filtre qui correspond à ces statuts (même liste, dans n'importe quel ordre), ou undefined. */
export function filtrePec(status) {
    const liste = Array.isArray(status) ? [...status].sort().join(",") : (status ?? "");
    return FILTRES_PEC.find(f => (Array.isArray(f.status) ? [...f.status].sort().join(",") : f.status) === liste);
}
